import { render, staticRenderFns } from "./headerTpl.vue?vue&type=template&id=a1b6e0a0&scoped=true&"
import script from "./headerTpl.vue?vue&type=script&lang=js&"
export * from "./headerTpl.vue?vue&type=script&lang=js&"
import style0 from "./headerTpl.vue?vue&type=style&index=0&id=a1b6e0a0&prod&lang=less&scoped=true&"
import style1 from "./headerTpl.vue?vue&type=style&index=1&id=a1b6e0a0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b6e0a0",
  null
  
)

export default component.exports